import { Badge, Body1Strong } from '@fluentui/react-components';
import { ShieldCheckmarkRegular } from '@fluentui/react-icons';

export const ConfidenceBadge = () => (
  <Badge appearance="outline" color="brand" size="extra-large" icon={<ShieldCheckmarkRegular />}>
    <Body1Strong>Confidence: Very high</Body1Strong>
  </Badge>
);
